<script lang="ts" setup>
import {computed, ref} from 'vue';
import {captureException, captureMessage} from "@sentry/browser";
import QuizButton from '@/components/Quiz/QuizButton.vue'
import QuizSecureTag from '@/components/Quiz/QuizSecureTag.vue'
import {useQuizStore} from '@/stores/quizStore';

type RegisterType = 'vin' | 'vrm'

const {goToNextStep, setVin, setVrm, vin, vrm, resetQuiz} = useQuizStore()

const register = ref(vin.value || vrm.value || '');
const registerType = ref<RegisterType>(vin.value ? 'vin' : 'vrm');

const buttonLabel = computed(() => registerType.value === 'vrm' ? 'VIN' : 'VRM');

const isValid = computed(() => register.value.length)

const toggleRegisterType = () => {
  registerType.value = registerType.value === 'vrm' ? 'vin' : 'vrm';
  register.value = '';
}

const handleSubmit = () => {
  if (!isValid.value) return;

  if (registerType.value === 'vrm') {
    setVrm(register.value)
    setVin('')
  } else {
    setVin(register.value)
    setVrm('')
  }
  goToNextStep()
}

function handleSearchByAddress() {
  resetQuiz()
    .then(() => {
      goToNextStep()
    })
    .catch((err) => {
      captureMessage("Error on resetQuiz: VehiclesIdentification.vue");
      captureException(err);
    })
}
</script>

<template>
  <h1 class="text-2xl font-bold text-(--brand-primary) pt-4 lg:pt-2 mb-2">Find out if you qualify
    for a car claim in seconds</h1>

  <p class="text-gray-600 mb-4 font-medium ">Begin with your REG number, we'll also check for
    other claims under your name.</p>

  <form @submit.prevent="handleSubmit">
    <input type="text"
           class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 mb-4 uppercase"
           placeholder="Enter the REG" v-model="register">

    <QuizButton label="Start Your Claim Check" :disabled="!isValid" id="vehicle-identification-submit-button"/>
  </form>

  <QuizSecureTag class="mt-6 mb-10"/>

  <p class="text-gray-600 mb-2 text-center font-medium">Don’t have a REG number?</p>

  <div class="flex items-center justify-center space-x-2 ">
    <p class="text-gray-600 font-medium text-xs sm:text-base">SEARCH BY:</p>
    <button @click="toggleRegisterType"  id="vehicle-identification-vin-vrm-button"
            class="border border-gray-300 rounded-xl px-6 py-1 text-gray-600 hover:bg-gray-50 focus:outline-none font-medium transition">
      {{ buttonLabel }}
    </button>
    <button @click="handleSearchByAddress"  id="vehicle-identification-address-button"
            class="border border-gray-300 rounded-xl px-4 py-1 text-gray-600 hover:bg-gray-50 focus:outline-none font-medium transition">
      ADDRESS
    </button>
  </div>

</template>
